/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dijit/_Container",
    "dojo/text!./templates/Panel.html",
    "./_WidgetMixin",
    "mw-form/mixins/ResizeMixin"
], function (declare, _WidgetBase, _TemplatedMixin, _Container, template, _WidgetMixin, ResizeMixin) {
    return declare([_WidgetBase, _TemplatedMixin, _Container, _WidgetMixin, ResizeMixin], {
        /** @lends Panel# */

        /**
         * @class Panel is a Container which can have Controls as it's children.
         * @extends dijit/_Container
         */
        templateString: template,

        addChild: function (child) {
            this.inherited(arguments);
            
            var parent = this.getParent();

            if (parent && parent.type === "Column") {
                parent.updateChildrenOrientations();
            }
        }
    });
});
